// Copyright (c) StrangeBee 2023

import { TimelineController, CustomEventInput, CustomEventType } from 'thehive-sdk';

export interface TimelineEventList {
    onCreate: (eventData: CustomEventInput, caseId: string) => Promise<CustomEventType | void>;
    onEdit: (eventData: Partial<CustomEventInput>, caseId: string) => Promise<CustomEventType | void>;
    onDelete: (eventId: string) => Promise<void>;
}

interface TimelineEventListParams {
    local: (label: string) => string;
    controller: TimelineController;
    onSuccess: (message: string, action?: string) => void;
    onError: (label?: string) => void;
}

const prepareData = (value: Partial<CustomEventInput>): Partial<CustomEventInput> => {
    let opt = {};

    const valueTreat = {
        ...value,
    };

    if (value.date && value.date?.valueOf) {
        opt = {
            ...opt,
            date: value.date?.valueOf(),
        };
    }
    if (value.endDate && value.endDate?.valueOf) {
        opt = {
            ...opt,
            endDate: value.endDate?.valueOf(),
        };
    }

    return { ...valueTreat, ...opt };
};

export const TimelineEventList = ({
    controller,
    local,
    onError,
    onSuccess,
}: TimelineEventListParams): TimelineEventList => ({
    onCreate: (eventData: CustomEventInput, caseId: string) => {
        const treatData = prepareData(eventData);

        return controller
            .create<Partial<CustomEventInput>, void>(treatData, caseId)
            .then((output) => {
                onSuccess(local('timeline.messages.create'), 'create');
                return output;
            })
            .catch(onError);
    },
    onEdit: (eventData: Partial<CustomEventInput>, customEventId: string) => {
        const treatData = prepareData(eventData);

        return controller
            .edit<Partial<CustomEventInput>, void>(treatData, customEventId)
            .then((output) => {
                onSuccess(local('timeline.messages.edit'), 'edit');
                return output;
            })
            .catch(onError);
    },
    onDelete: (eventId: string) =>
        controller
            .delete(eventId)
            .then(() => {
                onSuccess(local('timeline.messages.delete'), 'delete');
            })
            .catch(onError),
});
